import type { ScreenDef } from './types';

export const organisationFields: ScreenDef = {
    image: 'Organisation',
    sections: [
        {
            name: 'Organisation',
            entity: 'account',
            fields: [
                { field: 'accountnumber' },
                { field: 'lon_keyaccount' },
                { field: 'lon_operatinggrouprx', labelOverride: 'Operating Group' },
                { field: 'lon_primarygrouprx' },
                { field: 'lon_primarygroupotc' },
                { field: 'lon_rtsotc' },
                { field: 'lon_rtsrx' },
                { field: 'lon_ownergroup' },
                { field: 'lon_intellipharmcustomerid' },
                { field: 'lon_nostraid' },
                { field: 'lon_pharmaprogramid' },
            ],
        },
        {
            name: 'Address',
            entity: 'account',
            fields: [
                { field: 'address1_line1' },
                { field: 'address1_line2' },
                { field: 'address1_line3' },
                { field: 'address1_city' },
                { field: 'address1_stateorprovince' },
                { field: 'address1_postalcode' },
                { field: 'address1_country' },
            ],
        },
        {
            name: 'Contact Details',
            entity: 'account',
            fields: [
                { field: 'primarycontactid' },
                { field: 'primarycontactid.emailaddress1', labelOverride: 'Email' },
                { field: 'primarycontactid.telephone1', labelOverride: 'Business' },
                { field: 'telephone1', labelOverride: 'Phone' },
                { field: 'fax' },
                { field: 'emailaddress1', labelOverride: 'Email (RX/General EDM)' },
                { field: 'emailaddress2', labelOverride: 'Email (OTC EDM)' },
            ],
        },
        {
            entity: 'account',
            fields: [
                { field: 'lon_organisationtype' },
                { field: 'lon_primarywholesaleraccount', labelOverride: 'Primary Wholesaler Account (RX)' },
                { field: 'lon_PrimaryWholesalerAccount.lon_wholesaler', labelOverride: 'Wholesaler (RX)' },
                { field: 'lon_primarywholesaleraccountotc', labelOverride: 'Primary Wholesaler Account (OTC)' },
                { field: 'lon_PrimaryWholesalerAccountOTC.lon_wholesaler', labelOverride: 'Wholesaler (OTC)' },
                { field: 'lon_abn' },
                { field: 'lon_mpspharmacy' },
            ],
        },
        {
            name: 'Sales Rep Assignments',
            entity: 'lon_salesrepassignment',
            columns: [
                { field: 'lon_organisation' },
                { field: 'lon_salesrep' },
                { field: 'lon_division' },
            ],
        },
    ],
};
